import {
  createStyles,
  darken,
  lighten,
  Theme,
  withStyles,
  WithStyles
} from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none',
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'left',
      paddingTop: 8,
      paddingBottom: 8,
      '&$selected, &$selected:hover': {
        backgroundColor: theme.palette.action.selected
      },
      '&$disabled': {
        opacity: 0.5
      },

      border: `${theme.palette.primary.main} 1px solid`,
      boxShadow: `${theme.palette.primary.main} 1px 1px 9px -5px`,
      backgroundColor: darken(theme.palette.background.default, 0.03),
      marginBottom: theme.spacing(3),
      minHeight: '60px',
      ...(theme.palette.type === 'dark'
        ? {
            borderColor: darken(theme.palette.background.default, 0.1),
            backgroundColor: lighten(theme.palette.background.default, 0.1),
            boxShadow: `${darken(
              theme.palette.background.default,
              0.1
            )} 1px 1px 9px -5px`
          }
        : {})
    },
    /* Styles applied to the `component` element if dense. */
    dense: {
      paddingTop: 4,
      paddingBottom: 4
    },
    /* Styles applied to the `component` element if `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      alignItems: 'flex-start'
    },
    /* Styles applied to the `component` element if `justify="center"`. */
    justifyContentCenter: {
      justifyContent: 'center'
    },
    /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },
    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {}
  });

export interface SectionHeaderProps {
  alignItems?: 'flex-start' | 'center';
  justify?: 'flex-start' | 'center';
  dense?: boolean;
  disabled?: boolean;
  disableGutters?: boolean;
  selected?: boolean;
  title?: string;
  subTitle?: string;
}
type Props = SectionHeaderProps & WithStyles<typeof styles>;
const SectionHeader: React.FC<Props> = props => {
  const {
    alignItems = 'center',
    justify = 'flex-start',
    classes,
    dense = false,
    disabled = false,
    disableGutters = false,
    selected = false,
    children
  } = props;

  const className = clsx(classes.root, {
    [classes.dense]: dense,
    [classes.gutters]: !disableGutters,
    [classes.disabled]: disabled,
    [classes.alignItemsFlexStart]: alignItems === 'flex-start',
    [classes.justifyContentCenter]: justify === 'center',
    [classes.selected]: selected
  });

  return <div className={className}>{children}</div>;
};

export default withStyles<'root', {}, SectionHeaderProps>(styles, {
  name: 'FdSectionHeader'
})(SectionHeader);
